import { render } from "./ServiceRights.vue?vue&type=template&id=276b8d4d"
import script from "./ServiceRights.vue?vue&type=script&lang=js"
export * from "./ServiceRights.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__